import LinkCard from '@/modules/document/models/card/link-card.ts';
import { buildCardTitle, getVisibleEntityType } from '@/modules/common/models/card/card-display.util.ts';
import { markRaw } from 'vue';
import ClientType from '@/modules/common/enums/client-type.ts';
import ClientIcon from '@/assets/icons/counterparty/card/client.svg';
import DepartmentIcon from '@/assets/icons/counterparty/card/department.svg';
import LegalIcon from '@/assets/icons/counterparty/card/legal.svg';
import IpIcon from '@/assets/icons/counterparty/card/ip.svg';
import OwnLegalIcon from '@/assets/icons/counterparty/card/own-legal.svg';
import PrivatePersonIcon from '@/assets/icons/counterparty/card/private-person.svg';
import { TableId } from '@/modules/common/enums/table-id.enum.ts';
import type { IconComponent } from '@/modules/common/types/icon.type';

const ICONS = {
  [ClientType.Client]: ClientIcon,
  [ClientType.Department]: DepartmentIcon,
  [ClientType.Legal]: LegalIcon,
  [ClientType.IP]: IpIcon,
  [ClientType.OwnLegal]: OwnLegalIcon,
  [ClientType.PrivatePerson]: PrivatePersonIcon,
};

export default class ClientCard extends LinkCard {
  readonly tooltipLines: { label?: string; value: string }[];

  constructor(response: Record<string, unknown>) {
    const icon = markRaw(ICONS[response['TYPE_ID'] as keyof typeof ICONS] as unknown as IconComponent);
    super(response, 'CLIENT_ID', 'Название', icon, 'client', TableId.Counterparties);

    const number = response['Номер'] as string | number;
    const name = response['Название'] as string;
    const type = response['Тип'] as string;
    const visibleType = getVisibleEntityType(type, response['TYPE_ID'] === ClientType.Client);

    this.title = buildCardTitle(number, visibleType);
    this.subtitle = name;

    this.tooltipLines = [
      visibleType && { label: 'counterparty.shared.type', value: visibleType },
      { label: 'counterparty.field.name', value: name },
    ].filter(Boolean) as { label?: string; value: string }[];
  }
}
